import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { ImYoutube2 } from "react-icons/im";
import AppLinks from "../atoms/AppLinks";
const Footer = () => {
  return (
    <>
      <Wrapper>
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-7">
              <div className="row">
                <div className="col-sm-4 col-lg-4">
                  <h5 className="mt-0">Mi cuenta</h5>
                  <ul>
                    <li>
                      <Link to="/login">Iniciar Sesión</Link>
                    </li>
                    <li>
                      <Link to="/register">Registrarme</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-sm-4 col-lg-4">
                  <h5>Ayuda</h5>
                  <ul>
                    <li>
                      <Link to="/faqs">Preguntas frecuentes.</Link>
                    </li>
                    <li>
                      <Link to="/guias">Guías y Sugerencias </Link>
                    </li>
                    <li>
                      <a href="#">Manual de Uso</a>
                    </li>
                    <li>
                      <a href="#">Empresas Asociadas</a>
                    </li>
                  </ul>
                </div>
                <div className="col-sm-4 col-lg-4">
                  <h5>Legal</h5>
                  <ul>
                    <li>
                      <Link to="/privacy-policy">Políticas de Privacidad </Link>
                    </li>
                    <li>
                      <Link to="/terminos">Términos y Condiciones</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-sm-12">
                  <h5 className="mt-4 mt-lg-0">Contacto</h5>
                  <ul>
                    <li>
                      <a href="#">800 HEYBAJA (439-2252)</a>
                    </li>
                    <li>
                      <a href="#">
                        Ernesto J Piper #9 Piso PH, Col. Paseo de las Lomas
                      </a>
                    </li>
                    <li>
                      <a href="#">C.P. 01330 México D.F.</a>
                    </li>
                    <li>
                      <a
                        className="mailto"
                        href="mailto:contacto@bajatuseguro.com"
                      >
                        contacto@bajatuseguro.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-5">
              <div className="row">
                <div className="col-sm-12 col-lg-8">
                  <h5 className="mt-4 mt-lg-0">Síguenos en Redes Sociales</h5>
                  <ul className="social-link">
                    <li>
                      <a href="#">
                        <i>
                          <FaFacebookF />
                        </i>
                        Facebook
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i>
                          <FaInstagram />
                        </i>{" "}
                        Instagram
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i>
                          <FaTwitter />
                        </i>
                        Twitter
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="#">
                        <i>
                          <FaLinkedinIn />
                        </i>{" "}
                        LinkedIn
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="#">
                        <i>
                          <ImYoutube2 />
                        </i>{" "}
                        Youtube
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-sm-12 col-lg-4 app-link">
                  <h5 className="mt-4 mt-lg-0">Descárgala</h5>
                  <AppLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>

      <CopyWrapper>
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <p>
                <span>Bajatuseguro.com {new Date().getFullYear()} &copy;</span>{" "}
                - Todos los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </CopyWrapper>
    </>
  );
};

export default Footer;

const CopyWrapper = styled.div`
  color: #fff;
  background: #1a2a6a;

  p {
    font-size: 14px;
    margin-bottom: 0;
    padding: 10px 0;
    span {
      color: #3cdbc0;
    }
  }
`;

const Wrapper = styled.footer`
  padding: 35px 0 20px;
  background: #5268c2;
  color: #fff;

  h5 {
    color: #3cdbc0;
    font-size: 16px;
    font-weight: 700;
    text-transform: unset;
    letter-spacing: 1.1px;
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
  }

  ul li {
    padding: 0;
    line-height: 21px;
  }

  ul li a {
    color: #fff;
    letter-spacing: 0.9px;
    font-size: 14px;
  }

  ul li a:hover {
    color: #3cdbc0;
  }

  .social-link i {
    font-size: 22px;
  }

  .social-link li {
    padding: 8px 0;
  }

  .mailto {
    text-decoration: underline;
  }

  @media only screen and (max-width: 991px) {
    text-align: center;

    .social-link {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      li {
        padding: 8px 12px;
      }

      i {
        display: block;
        margin-bottom: 5px;
      }
    }
  }

  @media (max-width: 767px) {
    h5 {
      margin-top: 25px !important;
    }

    ul li a {
      font-size: 13px;
    }
  }
`;
